import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import VCurrencyField from "v-currency-field";
import { VTextField } from "vuetify/lib"; //Globally import VTextField

Vue.config.productionTip = false;

Vue.component("v-text-field", VTextField);
Vue.use(VCurrencyField, {
  locale: "da-DK",
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
